import React from 'react';
import '../css/FounderHero.css';

const FounderHero = () => {
  return (
    <header className="gfi-founder-hero-banner">
      
      {/* Dark Industrial Blue Overlay Film matching image 11_2 tint */}
      <div className="gfi-founder-hero-overlay"></div>

      <div className="gfi-founder-hero-container">
        <div className="gfi-founder-hero-content-box">
          
          {/* CENTERED PATH BREADCRUMB INDICATOR */}
          <nav className="gfi-founder-breadcrumb">
            <span className="gfi-f-bc-home">HOME</span>
            <span className="gfi-f-bc-divider">/</span>
            <span className="gfi-f-bc-current">FOUNDER & CEO MESSAGE</span>
          </nav>

          {/* MASTER DUAL-TONE HEADING */}
          <h1 className="gfi-founder-hero-title">
            FOUNDER & <span className="gfi-f-title-accent">CEO MESSAGE</span>
          </h1>

          {/* SUBTITLE WITH LEFT VERTICAL ACCENT ACCENT LINE */}
          <div className="gfi-founder-subtitle-wrapper">
            <div className="gfi-founder-vertical-accent-bar"></div>
            <p className="gfi-founder-subtitle-text">
              A personal vision for building professional excellence and career confidence.
            </p>
          </div>

        </div>
      </div>

    </header>
  );
};

export default FounderHero;